module.exports = __webpack_public_path__ + "img/a3acfc7f4b5b4700b28131a7301d7302.f15aebc2.png";